import { QUERY_PARAMS, ROUTES } from "@utils/constants";

import { PaymentSource } from "../constants";

const getRedirectPath = (source: PaymentSource, paymentId: string, isSuccess: boolean): string => {
  if (source === PaymentSource.SHIPMENTS) {
    const basePath = ROUTES.SHIPMENTS;
    const paymentIdParam = QUERY_PARAMS.SHIPMENT_PAYMENT_ID;
    const paymentSuccessParam = QUERY_PARAMS.SHIPMENT_PAYMENT_SUCCESS;
    const queryParams = new URLSearchParams({
      [paymentIdParam]: paymentId,
      [paymentSuccessParam]: isSuccess ? "true" : "false",
    });
    return `${basePath}?${queryParams.toString()}`;
  }

  if (source === PaymentSource.RDL) {
    const basePath = ROUTES.RDL_RESULT;
    const paymentIdParam = QUERY_PARAMS.PAYMENT_PAYMENT_ID;
    const paymentSuccessParam = QUERY_PARAMS.RDL_ORDER_SUCCESS;
    const queryParams = new URLSearchParams({
      [paymentSuccessParam]: isSuccess ? "true" : "false",
      [paymentIdParam]: paymentId,
    });
    return `${basePath}?${queryParams.toString()}`;
  }

  const basePath = isSuccess ? ROUTES.ORDER_SUCCESS : ROUTES.ORDER_SUMMARY;
  const paymentIdParam = QUERY_PARAMS.ORDER_PAYMENT_ID;
  const paymentSuccessParam = QUERY_PARAMS.ORDER_PAYMENT_SUCCESS;

  if (!isSuccess) {
    // Payment id is not needed when payment failed and it is from order flow
    return `${basePath}?${new URLSearchParams({ [paymentSuccessParam]: "false" }).toString()}`;
  }

  return `${basePath}?${new URLSearchParams({ [paymentIdParam]: paymentId }).toString()}`;
};

export default getRedirectPath;
